import React from 'react';

/**
 * Why the host currently refuses mutating actions (a stale revision, a pending
 * save, a blocker), or null. A workspace publishes it once around its sections
 * so element actions not marked read-only disable with that reason, instead of
 * every descriptor builder re-deriving the workspace's concurrency guard.
 */
const FmElementActionInhibitionContext = React.createContext<string | null>(null);

export const FmElementActionInhibitionProvider = FmElementActionInhibitionContext.Provider;

export function useElementActionInhibition(): string | null {
  return React.useContext(FmElementActionInhibitionContext);
}
